import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

/**
 * Poll for the count of active invocations associated with a dataset.
 */
export function useActiveInvocationCount(datasetId?: string) {
  const { datasetService } = useDomainServices();
  const { currentOrganization } = useAuth();

  return useQuery({
    queryKey: ["activeInvocationCount", datasetId],
    queryFn: async ({ signal }) => {
      if (currentOrganization === null) {
        return Promise.reject(new Error("Requires login"));
      }

      if (datasetId === undefined) {
        return Promise.reject(new Error("Requires datasetId"));
      }

      return await datasetService.countAssociatedActiveInvocations(
        datasetId,
        currentOrganization.org_id,
        { abortSignal: signal },
      );
    },
    enabled: currentOrganization !== null && datasetId !== undefined,
    refetchInterval: 5_000, // ms
    // Consider data stale immediately so it refetches on mount
    staleTime: 0,
  });
}
